import { STORE } from '@/store/store';

import { EnvironmentEnum as UsersEnvironmentEnum } from '@empathybroker/tsclient-users/dist/enums/environment.enum';

import { CONTAINER, TYPES, UsersClient } from 'playboard-core';

import { Store } from 'vuex';

CONTAINER.rebind<UsersClient>(TYPES.UsersClient).toDynamicValue(() => new UsersClient(UsersEnvironmentEnum.LIVE));

CONTAINER.rebind<Store<any>>(TYPES.Store).toConstantValue(STORE);
